var map = {
	"./directives/templates/developerMetricsAvailable.html": 37,
	"./directives/templates/friendRequest.html": 38,
	"./directives/templates/gameUpdateActionPopoverTemplate.html": 39,
	"./directives/templates/gameUpdateTemplate.html": 40,
	"./directives/templates/notificationContent.html": 41,
	"./directives/templates/notificationContentViewTemplate.html": 42,
	"./directives/templates/notificationStreamBase.html": 43,
	"./directives/templates/notificationStreamBaseView.html": 44,
	"./directives/templates/notificationStreamContainer.html": 45,
	"./directives/templates/privateMessage.html": 46,
	"./directives/templates/test.html": 47
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36;